import { InnerHtml } from '@/components/generic/InnerHtml';

export function QuestionDescription({ description }: { description: string }) {
  return (
    <InnerHtml html={description} className="ql-editor w-full max-w-5xl" />
  );
}
